import React from "react";
import "./Title.css";

export const Title = ({ title, color }) => (
    <h1 className={`project-title project-title-color-${color}`}>{title}</h1>
);
